import React from 'react';
import { PhoneCallIcon } from 'lucide-react';
const links = [{
  label: 'Termini di Servizio',
  href: '#termini'
}, {
  label: 'Politica sulla Privacy',
  href: '#privacy'
}, {
  label: 'Contatti',
  href: '#contatti'
}];
export function Footer() {
  return <footer className="w-full bg-night py-14 text-white md:py-16" data-id="element-68" data-mp="32lrn9grlb3lk">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-69" data-mp="36q94b86kf2sn">
        <p className="inline-flex items-center gap-2.5 font-display text-sm font-extrabold uppercase tracking-[0.14em] text-amber-400 md:text-base" data-id="element-70" data-mp="3uesc7mlpddk7">
          <span className="h-3 w-3 rounded-full bg-amber-400 ring-4 ring-amber-400/20" aria-hidden="true" data-id="element-71" data-mp="36mrsgl2ksqw" />
          Protocollo Settembre Giallo™
        </p>

        <p className="mt-6 text-sm text-gray-400" data-id="element-72" data-mp="3qfji2gmr3do4">
          © 2026 Protocollo Settembre Giallo™ | Tutti i diritti riservati
        </p>

        <p className="mt-6 inline-flex items-center gap-2 rounded-xl bg-gray-900 px-4 py-2.5 text-sm font-semibold text-amber-400 ring-1 ring-gray-800" data-id="element-73" data-mp="2eyt6sj3gzvnn">
          <PhoneCallIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-74" data-mp="3l9shv2i5sonf" />
          In caso di crisi, contatta il Numero Verde 800 334 343 o il 112 (Italia).
        </p>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-sm text-gray-300" data-id="element-75" data-mp="3v8rf7oxh4xv4">
          {links.map(link => <li key={link.label} data-id="element-76" data-mp="3qazp90ge3ltk">
              <a href={link.href} className="transition-colors duration-150 ease-calm hover:text-amber-400" data-id="element-77" data-mp="828ni7pom7a7">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-10 border-t border-gray-800 pt-6 text-xs leading-relaxed text-gray-500" data-id="element-78" data-mp="hs1vyzuj26a8">
          Questo prodotto è esclusivamente a scopo educativo e di sensibilizzazione. L’uso di queste
          risorse non sostituisce la terapia professionale, la diagnosi clinica o l’intervento
          medico. L’autore non si assume alcuna responsabilità per l’uso improprio delle dinamiche
          di gruppo.
        </p>
      </div>
    </footer>;
}